import { UTILITY_EVENT_TYPES } from "score-common";

// Utility event display metadata (card #755 — surfaces card #139's
// scribe/judge-raised BLOOD/LAMENESS flags on the admin ride page, which
// previously showed nothing for them). Mirrors
// apps/scribe-fe/src/util/utilityEventTypes.js: UTILITY_EVENT_TYPES is the
// canonical key enum the server validates against (score-common);
// label/severity here are pure FE presentation, not part of the wire schema.
export const UTILITY_EVENT_TYPE_LIST = [
  {
    key: UTILITY_EVENT_TYPES.BLOOD,
    label: "BLOOD",
    severity: "error",
  },
  {
    key: UTILITY_EVENT_TYPES.LAMENESS,
    label: "LAMENESS",
    severity: "warning",
  },
  // #1991 — not a welfare flag: a scribe flagging that the judge panel wants
  // a meeting. Mirrors apps/scribe-fe/src/util/utilityEventTypes.js's
  // MEETING_REQUESTED entry; this is the first "info" severity in this list
  // (BLOOD is error, LAMENESS is warning) — MUI Chip's `color` prop accepts
  // "info" natively, so RideEditor.jsx's existing
  // `color={cfg?.severity ?? "warning"}` needs no code change here.
  {
    key: UTILITY_EVENT_TYPES.MEETING_REQUESTED,
    label: "Meeting Requested",
    severity: "info",
  },
];

export const UTILITY_EVENT_TYPE_BY_KEY = Object.fromEntries(
  UTILITY_EVENT_TYPE_LIST.map((t) => [t.key, t]),
);
